import {environment} from '../../../environments/environment';

export const STORAGE_ROOT = `https://storage.googleapis.com/${environment.firebaseConfig.publicStorageBucket}/`;
export const TERMS_AND_CONDITIONS_DOWNLOAD_LINK = STORAGE_ROOT + $localize`legal/termsAndConditions/en.pdf`;
export const MANGOPAY_TOS_LINK = $localize`https://www.mangopay.com/terms/PSP/PSP_MANGOPAY_EN.pdf`;
